module.exports = __webpack_public_path__ + "static/media/dropdown-blue.81426d96.svg";